// extracted by mini-css-extract-plugin
module.exports = {"Benefits":"BenefitsNew_Benefits__r29hw","efmodal":"BenefitsNew_efmodal__lXXua"};